import { createSelector } from 'reselect'
import { get } from 'lodash'

import key from './types'
import { initialState } from './reducer'

const selectHome = state => get(state, key, initialState)

const selectLoading = createSelector(
  selectHome, state => get(state, 'loading', null)
)

const selectSuccess = createSelector(
  selectHome, state => get(state, 'dataHome', null)
)

const selectError = createSelector(
  selectHome, state => get(state, 'error', null)
)

export default {
  SUCCESS: selectSuccess,
  ERROR: selectError,
  LOADING: selectLoading
}
